/** 绿化分支 **/
import Layout from "@/views/layout/Layout";
// component: () => import("@/views/hrMan/orgPlan/index"),
const examRouter = {
  path: "/recruiting",
  component: Layout,
  redirect: "/examMan/course/list",
  name: "recruiting",
  meta: {
    title: "招聘管理",
    icon: "recruiting",
    roles: ["rec_zhaopinguanli"],
  },

  children: [
    {
      path: "jobDescriptionMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "jobDescriptionMan",
      meta: {
        title: "岗位说明书管理",
        roles: ["rec_gangweishuomingshuguanli"],
      },
      children: [
        {
          path: "maintenance",
          component: () =>
            import("@/views/recruiting/jobDescriptionMan/maintenance/index"),
          name: "maintenance",
          meta: {
            title: "岗位说明书维护",
            roles: ["rec_gangweishuomingshuweihu"],
          },
          children: [],
        },
        {
          path: "examineApprove",
          component: () =>
            import("@/views/recruiting/jobDescriptionMan/examineApprove/index"),
          name: "examineApprove",
          meta: {
            title: "岗位说明书审批",
            roles: ["rec_gangweishuomingshushenpi"],
          },
          children: [],
        },
        {
          path: "query",
          component: () =>
            import("@/views/recruiting/jobDescriptionMan/query/index"),
          name: "query",
          meta: {
            title: "岗位说明书查询",
            roles: ["rec_gangweishuomingshuchaxun"],
          },
          children: [],
        },
      ],
    },

    {
      path: "yearRecruitmentPlan",
      component: () =>
        import("@/views/recruiting/yearRecruitmentPlan/recruitmentPlan/index"),
      name: "yearRecruitmentPlan",
      meta: {
        title: "年度招聘计划",
        roles: ["rec_nianduzhaopinjihua"],
      },
      children: [
        // {
        //   path: "recruitmentPlan",
        //   component: () =>
        //     import(
        //       "@/views/recruiting/yearRecruitmentPlan/recruitmentPlan/index"
        //     ),
        //   name: "recruitmentPlan",
        //   meta: {
        //     title: "招聘计划查询",
        //     roles: ["rec_zhaopinjihuachaxun"],
        //   },
        //   children: [],
        // },
      ],
    },

    {
      path: "recruitmentDemandMan",
      component: () => import("@/views/recruiting/recruitmentDemandMan/index"),
      name: "recruitmentDemandMan",
      meta: {
        title: "招聘需求管理",
        roles: ["rec_zhaopinxuqiuguanli"],
      },
      children: [
        // {
        //   path: "recruitmentDemand",
        //   component: () =>
        //     import(
        //       "@/views/recruiting/recruitmentDemandMan/recruitmentDemand/index"
        //     ),
        //   name: "recruitmentDemand",
        //   meta: {
        //     title: "招聘需求查询",
        //     roles: ["rec_zhaopinxuqiuchaxun"],
        //   },
        //   children: [],
        // },
      ],
    },

    {
      path: "invitationMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "invitationMan",
      meta: {
        title: "邀约管理",
        roles: ["rec_yaoyueguanli"],
      },
      children: [
        {
          path: "interview",
          component: () =>
            import("@/views/recruiting/invitationMan/interview/index"),
          name: "interview",
          meta: {
            title: "面试邀约管理",
            roles: ["rec_mianshiyaoyueguanli"],
          },
          children: [],
        },
        {
          path: "query",
          component: () =>
            import("@/views/recruiting/invitationMan/query/index"),
          name: "query",
          meta: {
            title: "面试邀约查询",
            roles: ["rec_mianshiyaoyuechaxun"],
          },
          children: [],
        },
      ],
    },
    {
      path: "interviewMan",
      component: () =>
        import("@/views/recruiting/interviewMan/firstTryMan/index"),
      name: "interviewMan",
      meta: {
        title: "面试管理",
        roles: ["rec_mianshiguanli"],
      },
    },
    {
      path: "onboardingMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "onboardingMan",
      meta: {
        title: "入职管理",
        roles: ["rec_ruzhiguanli"],
      },
      children: [
        {
          path: "trainingMan",
          component: () =>
            import("@/views/recruiting/onboardingMan/trainingMan/index"),
          name: "trainingMan",
          meta: {
            title: "入职培训管理",
            roles: ["rec_ruzhipeixunguanli"],
          },
          children: [],
        },
        {
          path: "preEmploymentMan",
          component: () =>
            import("@/views/recruiting/onboardingMan/preEmploymentMan/index"),
          name: "preEmploymentMan",
          meta: {
            title: "待入职管理",
            roles: ["rec_dairuzhiguanli"],
          },
          children: [],
        },
        {
          path: "revokeEmploymentReview",
          component: () =>
            import(
              "@/views/recruiting/onboardingMan/revokeEmploymentReview/index"
            ),
          name: "revokeEmploymentReview",
          meta: {
            title: "撤销录用审核",
            roles: ["rec_chexiaoluyongshenhe"],
          },
          children: [],
        },
        {
          path: "revokeEmploymentQuery",
          component: () =>
            import(
              "@/views/recruiting/onboardingMan/revokeEmploymentQuery/index"
            ),
          name: "revokeEmploymentQuery",
          meta: {
            title: "撤销录用查询",
            roles: ["rec_chexiaoluyongchaxun"],
          },
          children: [],
        },
      ],
    },
    {
      path: "probationaryPeriodMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "probationaryPeriodMan",
      meta: {
        title: "试用期管理",
        roles: ["rec_shiyongqiguanli"],
      },
      children: [
        {
          path: "appraisalDuringProbation",
          component: () =>
            import(
              "@/views/recruiting/probationaryPeriodMan/appraisalDuringProbation/index"
            ),
          name: "appraisalDuringProbation",
          meta: {
            title: "试用期考核",
            roles: ["rec_shiyongqikaohe"],
          },
          children: [],
        },
        {
          path: "trialPeriodFinalReview",
          component: () =>
            import(
              "@/views/recruiting/probationaryPeriodMan/trialPeriodFinalReview/index"
            ),
          name: "trialPeriodFinalReview",
          meta: {
            title: "试用期终审",
            roles: ["rec_shiyongqizhongshen"],
          },
          children: [],
        },
        {
          path: "reporyJobMan",
          component: () =>
            import(
              "@/views/recruiting/probationaryPeriodMan/reporyJobMan/index"
            ),
          name: "reporyJobMan",
          meta: {
            title: "述职答卷管理",
            roles: ["rec_shuzhidajuanguanli"],
          },
          children: [],
        },
        {
          path: "probationaryScore",
          component: () =>
            import(
              "@/views/recruiting/probationaryPeriodMan/probationaryScore/index"
            ),
          name: "probationaryScore",
          meta: {
            title: "试用期综合成绩",
            roles: ["rec_shiyongqizonghechengji"],
          },
          children: [],
        },
      ],
    },
    {
      path: "talentPool",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "talentPool",
      meta: {
        title: "人才库",
        roles: ["rec_renyuanku"],
      },
      children: [
        {
          path: "manage",
          component: () => import("@/views/recruiting/talentPool/manage/index"),
          name: "manage",
          meta: {
            title: "管理层人才库",
            roles: ["rec_guanlicengrencaiku"],
          },
          children: [],
        },
        {
          path: "base",
          component: () => import("@/views/recruiting/talentPool/base/index"),
          name: "base",
          meta: {
            title: "基层人员库",
            roles: ["rec_jicengrenyuanku"],
          },
          children: [],
        },
      ],
    },
    {
      path: "reportMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "reportMan",
      meta: {
        title: "数据分析",
        roles: ["rec_shujufenxi"],
      },
      children: [
        {
          path: "turnoverRate",
          component: () =>
            import("@/views/recruiting/reportMan/turnoverRate/index"),
          name: "turnoverRate",
          meta: {
            title: "流失率统计表",
            roles: ["rec_liushilvtongjibiao"],
          },
          children: [],
        },
        {
          path: "onDutyRate",
          component: () =>
            import("@/views/recruiting/reportMan/onDutyRate/index"),
          name: "onDutyRate",
          meta: {
            title: "在岗率统计表",
            roles: ["rec_zaiganglvtongjibiao"],
          },
          children: [],
        },
        {
          path: "manRecruitDetails",
          component: () =>
            import("@/views/recruiting/reportMan/manRecruitDetails/index.vue"),
          name: "manRecruitDetails",
          meta: {
            title: "管理层招聘率统计表",
            roles: ["rec_guanlicengzhaopinlvtongjibiao"],
          },
          children: [],
        },

        {
          path: "grassrootsRecruitRate",
          component: () =>
            import("@/views/recruiting/reportMan/grassrootsRecruitRate/index"),
          name: "grassrootsRecruitRate",
          meta: {
            title: "基层招聘率统计表",
            roles: ["rec_jicengzhaopinlvtongjibiao"],
          },
          children: [],
        },
        {
          path: "overageSheet",
          component: () =>
            import("@/views/recruiting/reportMan/overageSheet/index"),
          name: "overageSheet",
          meta: {
            title: "超龄员工统计表",
            roles: ["rec_chaolingyuangongtongjibiao"],
          },
          children: [],
        },
        {
          path: "templateMain",
          component: () =>
            import("@/views/recruiting/reportMan/templateMain/index"),
          name: "templateMain",
          meta: {
            title: "统计部门模板维护",
            roles: ["rec_tongjibumenmobanweihu"],
          },
          children: [],
        },
        {
          path: "inputInfoDetails",
          component: () =>
            import("@/views/recruiting/reportMan/inputInfoDetails.vue"),
          name: "inputInfoDetails",
          meta: {
            title: "录入信息查询明细表",
            roles: ["rec_luruxinxichaxunmingxi"],
          },
        },
        {
          path: "inputInfoStatistics",
          component: () =>
            import("@/views/recruiting/reportMan/inputInfoStatistics.vue"),
          name: "inputInfoStatistics",
          meta: {
            title: "录入信息查询统计表",
            roles: ["rec_luruxinxichaxuntongji"],
          },
        },
        {
          path: "retrieveInfoQuery",
          component: () =>
            import("@/views/recruiting/reportMan/retrieveInfoQuery.vue"),
          name: "retrieveInfoQuery",
          meta: {
            title: "调出信息查询",
            roles: ["rec_diaochuxinxichaxun"],
          },
        },
      ],
    },
  ],
};

export default examRouter;
